import { render } from "./BaseDownloadContract.vue?vue&type=template&id=8d4bb316"
import script from "./BaseDownloadContract.vue?vue&type=script&lang=js"
export * from "./BaseDownloadContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__